import { STOCK_STATUSES, STOCK_TYPES } from 'constants/all';

import { getActivePartFileStatus } from 'modules/common/forms/materialWidget/data/reducer';

import { types } from './actions';

const initialState = {
  cachedNestingValues: null,
  hasFetchedSheets: false,
  hasNested: false,
  isFetchingSheets: false,
  isMounted: false,
  isRequestingNesting: false,
  nestingResult: null,
  sheets: [],
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.NESTING_REQUEST_ERROR:
    case types.NESTING_REQUEST_SUCCESS:
      return {
        ...state,
        isRequestingNesting: false,
      };
    case types.NESTING_REQUEST_SUBMIT:
      return {
        ...state,
        isRequestingNesting: true,
      };
    case types.RECEIVE_CACHED_NESTING_VALUES:
      return {
        ...state,
        cachedNestingValues: payload,
      };
    case types.RECEIVE_IS_MOUNTED:
      return {
        ...state,
        isMounted: payload.isMounted,
      };
    case types.RECEIVE_NESTING_RESULT:
      return {
        ...state,
        nestingResult: payload.nestingResult,
      };
    case types.RECEIVE_SHEETS:
      return {
        ...state,
        sheets: payload.sheets,
      };
    case types.RESET:
      return {
        ...initialState,
      };
    case types.RESET_SHEETS:
      return {
        ...state,
        hasFetchedSheets: false,
        sheets: [],
      };
    case types.SHEET_REQUEST_ERROR:
    case types.SHEET_REQUEST_SUCCESS:
      return {
        ...state,
        isFetchingSheets: false,
      };
    case types.SHEET_REQUEST_SUBMIT:
      return {
        ...state,
        hasFetchedSheets: true,
        isFetchingSheets: true,
        sheets: [],
      };
    default:
      return state;
  }
};

const getScope = (state) => state.modules.common.forms.materialWidget.sheet;

export const getCachedNestingValues = (state) =>
  getScope(state).cachedNestingValues;

export const getHasFetchedSheets = (state) => getScope(state).hasFetchedSheets;

export const getHasNested = (state) => getScope(state).hasNested;

export const getIsFetchingSheets = (state) => getScope(state).isFetchingSheets;

export const getIsInterrogatingSheet = (state) => {
  const status = getActivePartFileStatus(state);
  if (status) {
    return status[STOCK_TYPES.SHEET] === STOCK_STATUSES.INTERROGATING;
  } else {
    return false;
  }
};

export const getIsMounted = (state) => getScope(state).isMounted;

export const getIsNesting = (state) => {
  const status = getActivePartFileStatus(state);
  if (status) {
    return status.nesting === STOCK_STATUSES.INTERROGATING;
  } else {
    return false;
  }
};

export const getHasNestingFailed = (state) => {
  const status = getActivePartFileStatus(state);
  if (status) {
    return status.nesting === STOCK_STATUSES.FAILED;
  } else {
    return false;
  }
};

export const getIsRequestingNesting = (state) =>
  getScope(state).isRequestingNesting;

export const getNestingResult = (state) => getScope(state).nestingResult;

export const getSheets = (state) => getScope(state).sheets;

export default reducer;
